var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('prd-navigation-bar',[_c('b-button',{staticClass:"d-md-none btn-with-icon",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.toggleNavMenu}},[_c('i',{staticClass:"icon-menu"})]),_c('div',{staticClass:"d-md-none"},[_c('navigation-team')],1),_c('navigation-profile',{attrs:{"slot":"right"},slot:"right"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }